<div *transloco="let t">
  <app-dialog-title>
    @if (!isProductionMode) {
    <span
      >{{ isCreate ? t("settings.add") : t("settings.update") }}
      {{ "settings.type" | transloco }}</span
    >
    }
  </app-dialog-title>

  <mat-dialog-content>
    <div class="content">
      <form [formGroup]="form" class="ui form">
        <div class="field">
          <label>{{ "settings.name" | transloco }}</label>
          <input formControlName="taxReturnTypeName" class="form-control" />
        </div>
        <div class="field">
          <label>{{ "settings.key" | transloco }}</label>
          <input formControlName="taxReturnTypeKey" class="form-control" />
        </div>
        <div class="field">
          <app-search-dropdown
            label="Status"
            [formCtrl]="taxReturnTypeStatus"
            [listOptions]="taxReturnTypeStatusList"
          ></app-search-dropdown>
        </div>
        @if (syncToOneTeamEnabled) {
        <div class="field oneteam-sync">
          <label class="oneteam-sync-label">{{
            "settings.Sync-To-OneTeam" | transloco
          }}</label>
          <input
            type="checkbox"
            (input)="toggleSyncToOneTeam()"
            formControlName="syncToOneTeam"
            value="syncToOneTeamFlag"
            class="form-control"
          />
        </div>
        } @if (syncToOneTeamEnabled && syncToOneTeamFlag) {
        <div class="field">
          <label>{{ "settings.Engagement-Type" | transloco }}</label>
          <input formControlName="oneTeamEngagementType" class="form-control" />
        </div>
        } @if (syncToOneTeamEnabled && syncToOneTeamFlag) {
        <div class="field">
          <label>{{ "settings.Display-Name" | transloco }}</label>
          <input
            formControlName="oneTeamEngagementTypeDisplayName"
            class="form-control"
          />
        </div>
        }
      </form>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <a class="go-back cancel" (click)="onClose()">{{
      "settings.cancel" | transloco
    }}</a>
    @if (!isProductionMode) {
    <button
      [disabled]="form.invalid"
      (click)="saveTaxReturnType()"
      class="ui primary button"
    >
      {{ isCreate ? t("settings.add") : t("settings.update") }}
      {{ "settings.type" | transloco }}
    </button>
    }
  </mat-dialog-actions>
</div>
